(ns teamoesterreich.syncer
  (:require [cljs.core.async :refer [<! chan mult put! tap]]
            [clojure.walk]
            [teamoesterreich.admin-mode.data.organisation :as data-organisation]
            [teamoesterreich.admin-mode.data.user :as data-user]
            [teamoesterreich.admin-mode.event-ws :as event-ws]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state])
  )


(defn check-done []
  (when (and
          (get-in @v-state/app-state [:me :user-uuid])
          (count (get-in @v-state/app-state [:organisation-dst]))
          )
    (swap! v-state/app-state assoc :load-state :finished))
  (:load-state @v-state/app-state))


(defn get-me []
  (data-user/get-user-me (fn [data]
                           (log/debug "syncer get-me " (:error data))
                           (if (:error data)
                             (do
                               (swap! v-state/app-state assoc :error (:error data))
                               (swap! v-state/app-state assoc :error-status (:error-status data)))
                             (do
                               (swap! v-state/app-state assoc :me data)
                               (let [{tomId     :user-tomId
                                      firstName :user-firstName
                                      lastName  :user-lastName} data
                                     actual-user {:tom-id tomId
                                                  :name   {:first firstName :last lastName}}]
                                 (swap! v-state/app-state assoc :actual-user actual-user)
                                 )))
                           (check-done)
                           )))

(defn get-organisations []
  (data-organisation/<get-organisation-list
    (fn [data]
      (log/debug "syncer get-organisations " data)
      (swap! v-state/app-state assoc
             :organisation-dst data
             :organisation-dep data
             )
      (check-done)
      )))


(defn get-all [& [force]]
  (log/debug "get-all " force (:load-state @v-state/app-state))
  (when (or force (not= :loading (:load-state @v-state/app-state)))
    (swap! v-state/app-state assoc :load-state :loading)
    (get-me)
    (get-organisations)
    )
  (check-done)
  )









(let [ch (chan)]
  (event-ws/tap-update-listener ch
                                (fn [entity entity-uuid]
                                  ;(log/debug (str "Event `" (get-in @v-state/app-state [:selected-event :crowdtaskerEvent-uuid]) "` == `" entity-uuid "`")
                                  ;           (= (get-in @v-state/app-state [:selected-event :crowdtaskerEvent-uuid]) entity-uuid))

                                  ;; set callback trigger
                                  (let [now (h-date/now)]
                                    (swap! v-state/ws-state assoc :ws-event {(keyword entity) {:time now :last-uuid entity-uuid}})
                                    (log/debug "Ws-Event Update:" (clj->js (get-in @v-state/ws-state [:ws-event])))
                                    )


                                  ;; direct update TODO replace with ws-listener
                                  (cond
                                    ; :user-uuid
                                    (and (= entity "user") (= (get-in @v-state/app-state [:me :user-uuid]) entity-uuid)) (do (get-me) (data-user/user-update-by-uuid entity-uuid))
                                    (and (= entity "user") (get-in @v-state/app-state [:me :user-uuid])) (data-user/user-update-by-uuid entity-uuid)

                                    ))
                                ))